import { AssignmentTypeEnum, WorkerTypeEnum } from 'api/backofficeApiClient';

export const getWorkerTypeLabel = (workerType?: WorkerTypeEnum) => {
  switch (workerType) {
    case WorkerTypeEnum.IC:
      return 'IC';

    case WorkerTypeEnum.EE:
      return 'W2';

    case WorkerTypeEnum.InternationalIC:
      return 'International IC';

    case WorkerTypeEnum.SC:
      return 'SC';

    default:
      return '';
  }
};

export const getWorkerType = (
  workerType?: string,
): WorkerTypeEnum | undefined => {
  switch (workerType) {
    case 'IC':
      return WorkerTypeEnum.IC;

    case 'EE':
      return WorkerTypeEnum.EE;

    case 'International IC':
      return WorkerTypeEnum.InternationalIC;

    case 'SC':
      return WorkerTypeEnum.SC;

    default:
      return;
  }
};

export const getWorkerTypeByAssignmentType = (
  assignmentType?: AssignmentTypeEnum,
) => {
  switch (assignmentType) {
    case AssignmentTypeEnum.ICAssignment:
      return WorkerTypeEnum.IC;

    case AssignmentTypeEnum.EEAssignment:
      return WorkerTypeEnum.EE;

    case AssignmentTypeEnum.SCAssignment:
      return WorkerTypeEnum.SC;

    default:
      return undefined;
  }
};

export const workerTypesList = [
  {
    value: WorkerTypeEnum.EE,
    label: getWorkerTypeLabel(WorkerTypeEnum.EE),
  },
  {
    value: WorkerTypeEnum.IC,
    label: getWorkerTypeLabel(WorkerTypeEnum.IC),
  },
  {
    value: WorkerTypeEnum.InternationalIC,
    label: getWorkerTypeLabel(WorkerTypeEnum.InternationalIC),
  },
  {
    value: WorkerTypeEnum.SC,
    label: getWorkerTypeLabel(WorkerTypeEnum.SC),
  },
];
